// extracted by mini-css-extract-plugin
export default {"modalOverlay":"sH-z","modalContent":"tH-z","header":"uH-z","close":"vH-z"};